import { makeStyles } from "@mui/styles";
import Theme from "../../themes/theme";

export default makeStyles((theme: Theme) => {
  return {
    confirmDialog: {
      "& .MuiDialog-container": {
        height: "64%",
      },
      "& .MuiPaper-root": {
        minHeight: "380px !important",
        position: "fixed",
        margin: "64px",
        top: "0px",
      },
    },
    confirmModalWrapper: {
      minWidth: "500px",
    },
    closeIcon: {
      position: "absolute",
      right: 8,
      top: 8,
      "& svg": {
        fontSize: "30px",
      },
    },
    dialogContent: {
      textAlign: "center",
      minHeight: "200px",
      display: "flex",
      flexDirection: "column",
      "& div:first-child": {
        height: "140px",
        margin: "30px 0",
        "& svg": {
          overflow: "visible",
          position: "absolute",
          fontSize: "25px",
          left: "40%",
        },
      },
      "& div:nth-child(2)": {
        width: "45%",
        margin: "0 auto",
      },
    },
    actionButtons: {
      marginTop: "10%",
      marginBottom: "5%",
      "& button": {
        textTransform: "capitalize",
        fontWeight: 600,
      },
    },
    confirmBodyText: {
      marginBottom: "20px",
    },
    button: {
      marginRight: 8,
      marginLeft: 8,
      minWidth: "80px",
    },
    boldText: {
      fontWeight: 600,
    },
    fullWidthButton: {
      width: "100%",
      marginBottom: 12,
    },
  };
});
